import React, { useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Image, Tag, Dropdown, Popover } from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  CheckOutlined,
  CloseOutlined,
  EyeOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { AppTable } from "../common";

interface Contentdata {
  key?: string;
  _id: string;
  author?: {
    _id: string;
    email: string;
    profile_picture: string;
  };
  title: string;
  bodytext: string;
  image: string;
  adminStatus: string;
  createdAt: string;
  updatedAt: string;
}

// interface DataTableProps {
//     setshowModel: (value: boolean) => void,
//     setEditable: (value: boolean) => void,
//     deleteThought: (value: any) => void,
//     editContent:(value:any)=>void
//     isOpen: boolean,
//     contentData?: Contentdata[]
// }

function DataTableFourm({
  editFourm,
  setuserId,
  isLoading,
  updateFourm,
  setshowModel,
  setEditable,
  isOpen,
  contentData,
  deleteOtherContent,
  editContent,
}: any) {
  const [searchText, setSearchText] = useState("");

  const addDaysToDate = (date: any, daysToAdd: any) => {
    return moment(date).add(daysToAdd, "days").format("YYYY-MM-DD HH:mm:ss");
  };
  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      width: 180,
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      sorter: (a, b) => a._id.localeCompare(b._id),
      onFilter: (value, record) => {
        return (
          String(record.adminStatus)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record.author?.email)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?._id).toLowerCase().includes(value.toLocaleString()) ||
          String(record?.adminStatus)
            .toLowerCase()
            .includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Email",
      dataIndex: "author",
      key: "email",
      width: 200,
      render: (author) => author?.email,
    },

    {
      title: "Post Details",
      key: "seepost",
      width: 120,
      render: (_, record) => (
        <Space>
          {
            <Button
              onClick={() => {
                setEditable(true);
                editContent(record?._id);
                setuserId(record?._id);
              }}
              className="table_pill_btn table_pill_btn--view"
              icon={<EyeOutlined />}
            >
              See More
            </Button>
          }
        </Space>
      ),
    },
       {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 170,
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },

    {
      title: "Status",
      dataIndex: "poststatus",
      key: "poststatus",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          {record.adminStatus === "REJECTED" ? (
            <Tag color={"red"}>{record.adminStatus}</Tag>
          ) : record.adminStatus === "APPROVED" ? (
            <Tag color={"green"}>{record.adminStatus}</Tag>
          ) : record.adminStatus === "PENDING" ? (
            <Tag color={"orange"}>{record.adminStatus}</Tag>
          ) : null}
        </Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 150,
      render: (_, record) => (
        <Space size="middle">
          <Popover
            overlayClassName="status_popover"
            content={
              <div className="status_popover__actions">
                <Button
                  className="status_popover__btn status_popover__btn--approve"
                  icon={<CheckOutlined />}
                  onClick={() => updateFourm(record._id, "APPROVED")}
                >
                  Approve
                </Button>
                <Button
                  className="status_popover__btn status_popover__btn--reject"
                  icon={<CloseOutlined />}
                  onClick={() => updateFourm(record._id, "REJECTED")}
                >
                  Reject
                </Button>
              </div>
            }
            title="Update Status"
          >
            <Button
              className="table_pill_btn table_pill_btn--status"
              icon={<SyncOutlined />}
            >
              Update Status
            </Button>
          </Popover>
          {moment().format("YYYY-MM-DD HH:mm:ss") >
            addDaysToDate(record.updatedAt, 15) &&
          record.adminStatus === "REJECTED" ? (
            <Popover
              content={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <Button
                    style={{ backgroundColor: "green", width: "100%", color: "#fff" }}
                    onDoubleClick={() => deleteOtherContent(record._id)}
                  >
                    Yes
                  </Button>
                </div>
              }
              title="Please Double click to delete."
            >
              <Button className="btn_edit_table">Delete</Button>
            </Popover>
          ) : (
            ""
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        <div></div>
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default DataTableFourm;
